import type { PendingUserActivation, PendingUserPreview } from "@/users/types";
import { apiClient } from "./apiClient";

export const pendingUserGateway = {
  async getPendingUserPreview(
    token: string,
  ): Promise<PendingUserPreview | null> {
    return await apiClient.get(`/api/users/pending/preview/${token}`);
  },

  async activatePendingUser(
    token: string,
    activation: PendingUserActivation,
  ): Promise<void> {
    await apiClient.post(`/api/users/pending/activate/${token}`, activation);
  },
};
